import type { PaymentPlugin } from "../payment-plugin-registry";
import {
  AFRICA_BANNED_COUNTRIES,
  COMPLETELY_BANNED_COUNTRIES,
} from "@/lib/constants/config";
import { paytiko_payment_handler } from "./payment-handler";

export const paytiko_plugin: PaymentPlugin = {
  id: "paytiko",
  country_rules: {
    banned_countries: [
      ...COMPLETELY_BANNED_COUNTRIES,
    ],
  },
  process_payment: paytiko_payment_handler,
};
